import React from 'react';
import {useQuery} from "react-query";
import ngage from "services/ngage";
import Spinner from "components/Spinner";
import Empty from "components/Empty";
import {ClipboardListIcon} from "@heroicons/react/outline";

type Props = {
    exhibitId?: number
}

function ExhibitNotes({exhibitId}: Props) {
    let noteParams = {notableType: 'exhibit' as const, notableId: exhibitId || 0, page: 1}

    const {data: notes, isLoading: notesLoading} = useQuery(
        ['exhibit.notes', noteParams],
        () => ngage.notes.all(noteParams),
        {enabled: !!exhibitId}
    )

    if(notesLoading){
        return (
            <div className="my-8 flex items-center justify-center">
                <Spinner color={Spinner.colors.DARK}/>
            </div>
        )
    }

    if(!notesLoading && !(notes?.data.length)){
        return (
            <div className="bg-white mt-2 py-8">
                <Empty
                    icon={ClipboardListIcon}
                    text="No notes available"
                    hint="If a note is created for this exhibit it will appear here."
                />
            </div>
        )
    }

    return (
        <ul className="mb-2">
            {notes?.data.map(note => (
                <li key={note.id}>
                    <article className="mt-2 bg-white px-8 py-4">
                        <header className="flex">
                            <img
                                src={note.author.profile_photo_url}
                                alt={note.author.name}
                                className="rounded-full h-12"
                            />

                            <div className="ml-4">
                                <p className="font-medium">{note.author.name}</p>
                                <p className="text-gray-400 text-sm font-medium">{note.created_at.toRelative()}</p>
                            </div>
                        </header>

                        <div className="mt-6">
                            <h2 className="font-medium">{note.title}</h2>
                            <p className="whitespace-pre-line text-gray-400 font-normal">
                                {note.body}
                            </p>
                        </div>
                    </article>
                </li>
            ))}
        </ul>
    )
}

export default ExhibitNotes;